/** @format */

export const utilityGenerateRandomString = (path: string): string =>
  `${path}_${
    Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
  }`;
